export var MuiLink = {
    defaultProps: {
        underline: "hover",
    },
};
